import React, { Component } from 'react';
class Subtitles extends Component {
  constructor(props) {
    super(props);
    
  }

  render() {
    const { label, default: isDefault, srcLang = 'en' } = this.props;

    console.log(this.props.subtitles)
    let subtitles = undefined
    if(this.props.subtitles) {
      subtitles =  require(`../subtitles/${this.props.subtitles}`) || null;
    }
 

    return (
        <track
          src={subtitles}
          kind="subtitles"
          srcLang="en"
          label={label}
          default={isDefault ? true : false}
        />
    );
  }
}

export default Subtitles;


// WEBPACK FOOTER //
// ./src/components/subtitles.js